// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ✅ VidangePage.css — style homogène avec matériel */

.vd-page {
    --vd-bg: #f5f5db;
    --vd-text: #6d4e36;
    --vd-accent: #8b5e3c;
    --vd-soft: rgba(0, 0, 0, 0.04);
    --vd-border: rgba(0, 0, 0, 0.08);
    --vd-head: rgba(0, 0, 0, 0.03);
  
    --vd-ok: rgba(31, 138, 76, 0.10);
    --vd-warn: rgba(255, 193, 7, 0.16);
    --vd-danger: rgba(220, 53, 69, 0.14);
  
    --vd-shadow: 0 10px 26px rgba(0, 0, 0, 0.06);
  }
  
  .vd-card {
    border-radius: 16px !important;
    border: 1px solid var(--vd-border) !important;
    box-shadow: var(--vd-shadow);
  }
  
  .vd-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }
  
  .vd-title {
    color: var(--vd-text);
    font-weight: 900;
    margin: 0;
  }
  
  .vd-subtitle {
    color: rgba(0, 0, 0, 0.55);
    font-weight: 700;
  }
  
  .vd-table-wrap {
    border-radius: 16px;
    overflow: hidden;
    border: 1px solid var(--vd-border);
    box-shadow: var(--vd-shadow);
    background: #fff;
  }
  
  .vd-table-wrap .table {
    margin-bottom: 0 !important;
  }
  
  .vd-table-wrap .table thead th {
    background: var(--vd-head) !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.10) !important;
    font-weight: 900;
    color: var(--vd-text);
    vertical-align: middle;
    min-width: 120px;
  }
  
  .vd-table-wrap .table tbody tr:hover td {
    background: rgba(0, 0, 0, 0.02) !important;
  }
  
  .vd-row-ok td {
    background: linear-gradient(90deg, var(--vd-ok), rgba(31, 138, 76, 0.02)) !important;
  }
  
  .vd-row-alerte td {
    background: linear-gradient(90deg, var(--vd-warn), rgba(255, 193, 7, 0.03)) !important;
  }
  
  .vd-row-critique td,
  .vd-row-depasse td {
    background: linear-gradient(90deg, var(--vd-danger), rgba(220, 53, 69, 0.03)) !important;
  }
  
  .vd-badge {
    border-radius: 999px;
    padding: 7px 10px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-weight: 900;
  }
  
  .vd-table-wrap input,
  .vd-table-wrap select {
    border-radius: 10px !important;
    font-size: 12px;
  }
  
  .vd-kpi-grid {
    display: grid;
    grid-template-columns: repeat(5, minmax(160px, 1fr));
    gap: 12px;
  }
  
  @media (max-width: 1200px) {
    .vd-kpi-grid {
      grid-template-columns: repeat(3, minmax(160px, 1fr));
    }
  }
  
  @media (max-width: 768px) {
    .vd-kpi-grid {
      grid-template-columns: repeat(2, minmax(160px, 1fr));
    }
  }
  
  .vd-kpi-card {
    border-radius: 16px;
    border: 1px solid var(--vd-border);
    box-shadow: var(--vd-shadow);
    background: #fff;
    padding: 14px 14px;
    position: relative;
    overflow: hidden;
  }
  
  .vd-kpi-card::before {
    content: "";
    position: absolute;
    inset: 0;
    opacity: 0.14;
    pointer-events: none;
  }
  
  .vd-kpi-card.kpi-total::before { background: #000; }
  .vd-kpi-card.kpi-ok::before { background: #198754; }
  .vd-kpi-card.kpi-alerte::before { background: #ffc107; }
  .vd-kpi-card.kpi-critique::before { background: #dc3545; }
  .vd-kpi-card.kpi-depasse::before { background: #b02a37; }
  
  .vd-kpi-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }
  
  .vd-kpi-label {
    font-weight: 900;
    color: var(--vd-text);
    margin: 0;
  }
  
  .vd-kpi-value {
    font-size: 28px;
    font-weight: 1000;
    color: rgba(0, 0, 0, 0.78);
    margin-top: 6px;
    line-height: 1;
  }
  
  .vd-kpi-hint {
    margin-top: 8px;
    font-weight: 700;
    color: rgba(0, 0, 0, 0.55);
    font-size: 12px;
  }
  
  .vd-kpi-icon {
    width: 38px;
    height: 38px;
    border-radius: 12px;
    display: grid;
    place-items: center;
    border: 1px solid var(--vd-border);
    background: rgba(0, 0, 0, 0.03);
    color: var(--vd-text);
  }`, "",{"version":3,"sources":["webpack://./src/styles/VidangePage.css"],"names":[],"mappings":"AAAA,qDAAqD;;AAErD;IACI,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,8BAA8B;IAC9B,gCAAgC;IAChC,8BAA8B;;IAE9B,gCAAgC;IAChC,kCAAkC;IAClC,oCAAoC;;IAEpC,4CAA4C;EAC9C;;EAEA;IACE,8BAA8B;IAC9B,6CAA6C;IAC7C,4BAA4B;EAC9B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,qBAAqB;IACrB,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,kCAAkC;IAClC,4BAA4B;IAC5B,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,qCAAqC;IACrC,uDAAuD;IACvD,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,oFAAoF;EACtF;;EAEA;IACE,sFAAsF;EACxF;;EAEA;;IAEE,wFAAwF;EAC1F;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;EAClB;;EAEA;;IAEE,8BAA8B;IAC9B,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,SAAS;EACX;;EAEA;IACE;MACE,oDAAoD;IACtD;EACF;;EAEA;IACE;MACE,oDAAoD;IACtD;EACF;;EAEA;IACE,mBAAmB;IACnB,kCAAkC;IAClC,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb,oBAAoB;EACtB;;EAEA,iCAAiC,gBAAgB,EAAE;EACnD,8BAA8B,mBAAmB,EAAE;EACnD,kCAAkC,mBAAmB,EAAE;EACvD,oCAAoC,mBAAmB,EAAE;EACzD,mCAAmC,mBAAmB,EAAE;;EAExD;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;IACrB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,0BAA0B;IAC1B,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,kCAAkC;IAClC,+BAA+B;IAC/B,qBAAqB;EACvB","sourcesContent":["/* ✅ VidangePage.css — style homogène avec matériel */\r\n\r\n.vd-page {\r\n    --vd-bg: #f5f5db;\r\n    --vd-text: #6d4e36;\r\n    --vd-accent: #8b5e3c;\r\n    --vd-soft: rgba(0, 0, 0, 0.04);\r\n    --vd-border: rgba(0, 0, 0, 0.08);\r\n    --vd-head: rgba(0, 0, 0, 0.03);\r\n  \r\n    --vd-ok: rgba(31, 138, 76, 0.10);\r\n    --vd-warn: rgba(255, 193, 7, 0.16);\r\n    --vd-danger: rgba(220, 53, 69, 0.14);\r\n  \r\n    --vd-shadow: 0 10px 26px rgba(0, 0, 0, 0.06);\r\n  }\r\n  \r\n  .vd-card {\r\n    border-radius: 16px !important;\r\n    border: 1px solid var(--vd-border) !important;\r\n    box-shadow: var(--vd-shadow);\r\n  }\r\n  \r\n  .vd-header {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap: 12px;\r\n  }\r\n  \r\n  .vd-title {\r\n    color: var(--vd-text);\r\n    font-weight: 900;\r\n    margin: 0;\r\n  }\r\n  \r\n  .vd-subtitle {\r\n    color: rgba(0, 0, 0, 0.55);\r\n    font-weight: 700;\r\n  }\r\n  \r\n  .vd-table-wrap {\r\n    border-radius: 16px;\r\n    overflow: hidden;\r\n    border: 1px solid var(--vd-border);\r\n    box-shadow: var(--vd-shadow);\r\n    background: #fff;\r\n  }\r\n  \r\n  .vd-table-wrap .table {\r\n    margin-bottom: 0 !important;\r\n  }\r\n  \r\n  .vd-table-wrap .table thead th {\r\n    background: var(--vd-head) !important;\r\n    border-bottom: 1px solid rgba(0, 0, 0, 0.10) !important;\r\n    font-weight: 900;\r\n    color: var(--vd-text);\r\n    vertical-align: middle;\r\n    min-width: 120px;\r\n  }\r\n  \r\n  .vd-table-wrap .table tbody tr:hover td {\r\n    background: rgba(0, 0, 0, 0.02) !important;\r\n  }\r\n  \r\n  .vd-row-ok td {\r\n    background: linear-gradient(90deg, var(--vd-ok), rgba(31, 138, 76, 0.02)) !important;\r\n  }\r\n  \r\n  .vd-row-alerte td {\r\n    background: linear-gradient(90deg, var(--vd-warn), rgba(255, 193, 7, 0.03)) !important;\r\n  }\r\n  \r\n  .vd-row-critique td,\r\n  .vd-row-depasse td {\r\n    background: linear-gradient(90deg, var(--vd-danger), rgba(220, 53, 69, 0.03)) !important;\r\n  }\r\n  \r\n  .vd-badge {\r\n    border-radius: 999px;\r\n    padding: 7px 10px;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    font-weight: 900;\r\n  }\r\n  \r\n  .vd-table-wrap input,\r\n  .vd-table-wrap select {\r\n    border-radius: 10px !important;\r\n    font-size: 12px;\r\n  }\r\n  \r\n  .vd-kpi-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(5, minmax(160px, 1fr));\r\n    gap: 12px;\r\n  }\r\n  \r\n  @media (max-width: 1200px) {\r\n    .vd-kpi-grid {\r\n      grid-template-columns: repeat(3, minmax(160px, 1fr));\r\n    }\r\n  }\r\n  \r\n  @media (max-width: 768px) {\r\n    .vd-kpi-grid {\r\n      grid-template-columns: repeat(2, minmax(160px, 1fr));\r\n    }\r\n  }\r\n  \r\n  .vd-kpi-card {\r\n    border-radius: 16px;\r\n    border: 1px solid var(--vd-border);\r\n    box-shadow: var(--vd-shadow);\r\n    background: #fff;\r\n    padding: 14px 14px;\r\n    position: relative;\r\n    overflow: hidden;\r\n  }\r\n  \r\n  .vd-kpi-card::before {\r\n    content: \"\";\r\n    position: absolute;\r\n    inset: 0;\r\n    opacity: 0.14;\r\n    pointer-events: none;\r\n  }\r\n  \r\n  .vd-kpi-card.kpi-total::before { background: #000; }\r\n  .vd-kpi-card.kpi-ok::before { background: #198754; }\r\n  .vd-kpi-card.kpi-alerte::before { background: #ffc107; }\r\n  .vd-kpi-card.kpi-critique::before { background: #dc3545; }\r\n  .vd-kpi-card.kpi-depasse::before { background: #b02a37; }\r\n  \r\n  .vd-kpi-top {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap: 10px;\r\n  }\r\n  \r\n  .vd-kpi-label {\r\n    font-weight: 900;\r\n    color: var(--vd-text);\r\n    margin: 0;\r\n  }\r\n  \r\n  .vd-kpi-value {\r\n    font-size: 28px;\r\n    font-weight: 1000;\r\n    color: rgba(0, 0, 0, 0.78);\r\n    margin-top: 6px;\r\n    line-height: 1;\r\n  }\r\n  \r\n  .vd-kpi-hint {\r\n    margin-top: 8px;\r\n    font-weight: 700;\r\n    color: rgba(0, 0, 0, 0.55);\r\n    font-size: 12px;\r\n  }\r\n  \r\n  .vd-kpi-icon {\r\n    width: 38px;\r\n    height: 38px;\r\n    border-radius: 12px;\r\n    display: grid;\r\n    place-items: center;\r\n    border: 1px solid var(--vd-border);\r\n    background: rgba(0, 0, 0, 0.03);\r\n    color: var(--vd-text);\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
